import React from 'react';

import ReactDOM from 'react-dom';
import ReduxToastr from 'react-redux-toastr';
import {PersistGate} from 'redux-persist/integration/react';
import {BrowserRouter} from 'react-router-dom';
import {Provider as StoreProvider} from 'react-redux';

import {ScrollToTop} from '@britishcouncil/react-common';

import {persistor, store} from './store/store';
import * as serviceWorker from './serviceWorker';
import {App} from './App';
import {BackendUrlInterceptor} from './core/interceptors/backend-url-interceptor';
import {AppSettingsProvider} from './core/app-settings/AppSettingsProvider';
import {AuthProvider} from "./pages";

ReactDOM.render(
    <React.StrictMode>
        <StoreProvider store={store}>
            <BrowserRouter>
                <PersistGate persistor={persistor} loading={false}>
                    <AppSettingsProvider>
                        <AuthProvider>
                            <BackendUrlInterceptor/>
                            <ScrollToTop/>
                            <App/>
                            <ReduxToastr
                                timeOut={4000}
                                newestOnTop={false}
                                preventDuplicates
                                position="bottom-right"
                                transitionIn="fadeIn"
                                transitionOut="fadeOut"
                                progressBar
                                closeOnToastrClick
                            />
                        </AuthProvider>
                    </AppSettingsProvider>
                </PersistGate>
            </BrowserRouter>
        </StoreProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
